import { styled } from "@mui/material"

const TabPanel = styled("div")`
  width: 100%;
  height: 100%;
  margin: 1rem 0;
`

export default TabPanel
